<p-dialog
    [(visible)]="visible"
    appendTo="body"
    [modal]="modal"
    [closable]="closable"
    [draggable]="draggable"
    [style]="{ 'max-width': '700px', width: '100%' }"
    header="DUPLICATE EPISODE"
    (onHide)="onHide.emit($event)">
    <div>
        <div *ngIf="duplicateEpisodes.length">
            <div class="text-message-header text-center mt-3 mb-3 ">
                An episode with the same diagnosis already exists.
                <p>Please select one to continue or create a new episode</p>
            </div>

            <div class="flex justify-content-between mb-3 align-items-center gap-20"   *ngFor="let item of duplicateEpisodes; let i = index">
                <duplicate-episode-ribbon (click)="emitViewEpisode(item.id)" class="fg-1" [episode]="item" ></duplicate-episode-ribbon>
                <p-radioButton *ngIf="isWalkInDraft || isPrescription || isForm" class="margin-left-15 fg-0" name="episode" [value]="item.id" [(ngModel)]="selectedEpisodeId"></p-radioButton>
            </div>
        </div>

        <div *ngIf="duplicateBodyPartSide.length" [ngClass]="{ 'bodypart-border-top': duplicateEpisodes.length !== 0 }">
            <div class="text-message-header text-center mb-3 mt-3">Matching Body Part/Body Side - did you mean….</div>
            <div  class="flex justify-content-between mb-3 align-items-center gap-20" *ngFor="let item of duplicateBodyPartSide; let i = index">
                <duplicate-episode-ribbon *ngIf="isWalkInDraft && !tempWalkIn; else viewEpisode" [showViewButton]="false" class="fg-1" [episode]="item" [showHover]="false"></duplicate-episode-ribbon> 
                <ng-template #viewEpisode>
                    <duplicate-episode-ribbon  (click)="emitViewEpisode(item.id)" [showViewButton]="true" class="fg-1" [episode]="item"></duplicate-episode-ribbon> 
                </ng-template>
                <p-radioButton *ngIf="isWalkInDraft || isPrescription || isForm " class="margin-left-15 fg-0"  name="episode" [value]="item.id" [(ngModel)]="selectedEpisodeId"></p-radioButton>
            </div>
         </div>

        <div class="buttons-panel buttons-panel-center-alignment ">
            <button pButton type="button" label="Cancel" class="p-button-secondary" (click)="closeDialog()"></button>
            <button pButton type="button" class="m-button-primary" label="Create New Episode" (click)="emitCreateEpisode()"></button>
            <button
                *ngIf="selectedEpisodeId"
                pButton
                type="button"
                class="m-button-primary"
                label="Select Existing Episode"
                (click)="emitSelectExistingEpisode()"></button>
        </div>
    </div>
</p-dialog>